
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 3.02a3 3 0 013 0l5.526 3.191a3 3 0 011.5 2.598v6.382a3 3 0 01-1.5 2.598l-5.526 3.19a3 3 0 01-3 0l-5.526-3.19a3 3 0 01-1.5-2.598V8.809a3 3 0 011.5-2.598l5.526-3.19z","stroke":"currentColor","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"3","stroke":"currentColor","stroke-width":"2"}})])
          )
        }
      }
    